import React from "react";

export const TicketDetailContext = React.createContext(null);

export const useTicketDetailContext = () => {
  const context = React.useContext(TicketDetailContext);

  if (!context) throw new Error("Ticket Detail Context not provided!");

  return context;
};
